<div class="product-share">
    <div class="socials">
        <div class="social"><i class="fas fa-share-alt fa-1x"></i></div>
        <div class="social">
            <i class="fab fa-twitter fa-1x" aria-hidden="true"></i>
        </div>
        <div class="social">
            <i _ngcontent-qeb-c317="" class="fab fa-facebook fa-1x"></i>
        </div>
        <div class="social">
            <i class="fab fa-whatsapp fa-1x" aria-hidden="true"></i>
        </div>
        <div class="social">
            <i class="fab fa-snapchat fa-1x"></i>
        </div>
    </div>
</div>
